import React, { useEffect, useState } from "react";
import { IconButton, Box, TextField, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "./SearchBox.scss";
import { SEARCHBOX } from "../../../data/constants";

interface SearchBoxProps {
  searchPlaceholder: string;
  onSearch: (searchText: string) => void;
  clearSignal?: number;
}

const SearchBox: React.FC<SearchBoxProps> = ({ searchPlaceholder, onSearch, clearSignal }) => {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, SEARCHBOX.DEBOUNCE_TIME);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  useEffect(() => {
    const trimmed = debouncedSearchText.trim();
    onSearch(trimmed);
  }, [debouncedSearchText, onSearch]);

  useEffect(() => {
    if (clearSignal > 0) {
      setSearchText("");
      onSearch("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSignal]);

  const handleClear = () => {
    setSearchText("");
  };

  const handleSearch = () => {
    onSearch(searchText.trim());
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setSearchText(event.target.value);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <Box className="search-box">
      <TextField
        label={searchPlaceholder}
        variant="outlined"
        id="SearchBox"
        size="small"
        autoComplete="off"
        value={searchText}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        fullWidth
        InputProps={{
          endAdornment: (
            <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
              {searchText && (
                <Tooltip title="Clear search" placement="top">
                  <IconButton onClick={handleClear} size="small" id="clearButton">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Search" placement="top">
                <IconButton
                  onClick={handleSearch}
                  size="small"
                  sx={{
                    height: "40px",
                    width: "40px",
                    minWidth: 0,
                    borderRadius: 0,
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    backgroundColor: "#F57F43",
                    marginRight: "-8px",
                    "&:hover": {
                      backgroundColor: "#F57F43",
                    },
                  }}
                >
                  <SearchIcon sx={{ color: "#fff", fontSize: 20 }} />
                </IconButton>
              </Tooltip>
            </Box>
          ),
          sx: {
            height: "40px",
            alignItems: "center",
            paddingRight: 1,
          },
        }}
      />
    </Box>
  );
};

export default SearchBox;
